// Centralized mutation side-effect helpers (cache invalidations, etc.)
// Keeping queryClient.invalidateQueries usages isolated so action hooks remain focused on domain logic.
import { qk } from './queryKeys'

export const invalidatePreviousAnswerGroups = (queryClient, activityGroupId) => {
  if (!queryClient || !activityGroupId) return
  queryClient.invalidateQueries({ queryKey: qk.previousAnswerGroups(activityGroupId) })
  queryClient.invalidateQueries({ queryKey: qk.activityGroupAnswers(activityGroupId) })
}

export const invalidatePoints = (queryClient) => {
  if (!queryClient) return
  queryClient.invalidateQueries({ queryKey: qk.myPoints() })
  queryClient.invalidateQueries({ queryKey: qk.points() })
}
